export class ConfiguracoesForm {
  public static aprovaCliente;
  public static produtoDetalhe
  static cadastroCliente: any;
  static pedidos: any;
  public static clienteEcommerce: any
  public static patchAppConfig(c) {
    this.aprovaCliente = c.aprovaCliente;
    this.produtoDetalhe = c.produtoDetalhe
    this.cadastroCliente = c.cadastroCliente
    this.clienteEcommerce = c.clienteEcommerce
    this.pedidos = c.pedidos
  }
}